/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * AiFeedbackResultApi - axios parameter creator
 * @export
 */
export const AiFeedbackResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * AIフィードバックリマインドキャンセルAPI
         * @summary AIフィードバックリマインドキャンセルAPI
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiFeedbackResultCancelReminder: async (aiFeedbackResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiFeedbackResultId' is not null or undefined
            assertParamExists('postAiFeedbackResultCancelReminder', 'aiFeedbackResultId', aiFeedbackResultId)
            const localVarPath = `/api/user/ai_feedback_results/{aiFeedbackResultId}/cancel_reminder`
                .replace(`{${"aiFeedbackResultId"}}`, encodeURIComponent(String(aiFeedbackResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * AIフィードバック確認API
         * @summary AIフィードバック確認API
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiFeedbackResultConfirm: async (aiFeedbackResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiFeedbackResultId' is not null or undefined
            assertParamExists('postAiFeedbackResultConfirm', 'aiFeedbackResultId', aiFeedbackResultId)
            const localVarPath = `/api/user/ai_feedback_results/{aiFeedbackResultId}/confirm`
                .replace(`{${"aiFeedbackResultId"}}`, encodeURIComponent(String(aiFeedbackResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * AIフィードバックリマインドAPI
         * @summary AIフィードバックリマインドAPI
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiFeedbackResultRemind: async (aiFeedbackResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiFeedbackResultId' is not null or undefined
            assertParamExists('postAiFeedbackResultRemind', 'aiFeedbackResultId', aiFeedbackResultId)
            const localVarPath = `/api/user/ai_feedback_results/{aiFeedbackResultId}/remind`
                .replace(`{${"aiFeedbackResultId"}}`, encodeURIComponent(String(aiFeedbackResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiFeedbackResultApi - functional programming interface
 * @export
 */
export const AiFeedbackResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiFeedbackResultApiAxiosParamCreator(configuration)
    return {
        /**
         * AIフィードバックリマインドキャンセルAPI
         * @summary AIフィードバックリマインドキャンセルAPI
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAiFeedbackResultCancelReminder(aiFeedbackResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAiFeedbackResultCancelReminder(aiFeedbackResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * AIフィードバック確認API
         * @summary AIフィードバック確認API
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAiFeedbackResultConfirm(aiFeedbackResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAiFeedbackResultConfirm(aiFeedbackResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * AIフィードバックリマインドAPI
         * @summary AIフィードバックリマインドAPI
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAiFeedbackResultRemind(aiFeedbackResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAiFeedbackResultRemind(aiFeedbackResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AiFeedbackResultApi - factory interface
 * @export
 */
export const AiFeedbackResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiFeedbackResultApiFp(configuration)
    return {
        /**
         * AIフィードバックリマインドキャンセルAPI
         * @summary AIフィードバックリマインドキャンセルAPI
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiFeedbackResultCancelReminder(aiFeedbackResultId: number, options?: any): AxiosPromise<void> {
            return localVarFp.postAiFeedbackResultCancelReminder(aiFeedbackResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * AIフィードバック確認API
         * @summary AIフィードバック確認API
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiFeedbackResultConfirm(aiFeedbackResultId: number, options?: any): AxiosPromise<void> {
            return localVarFp.postAiFeedbackResultConfirm(aiFeedbackResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * AIフィードバックリマインドAPI
         * @summary AIフィードバックリマインドAPI
         * @param {number} aiFeedbackResultId AIフィードバックID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAiFeedbackResultRemind(aiFeedbackResultId: number, options?: any): AxiosPromise<void> {
            return localVarFp.postAiFeedbackResultRemind(aiFeedbackResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiFeedbackResultApi - interface
 * @export
 * @interface AiFeedbackResultApi
 */
export interface AiFeedbackResultApiInterface {
    /**
     * AIフィードバックリマインドキャンセルAPI
     * @summary AIフィードバックリマインドキャンセルAPI
     * @param {number} aiFeedbackResultId AIフィードバックID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiFeedbackResultApiInterface
     */
    postAiFeedbackResultCancelReminder(aiFeedbackResultId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * AIフィードバック確認API
     * @summary AIフィードバック確認API
     * @param {number} aiFeedbackResultId AIフィードバックID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiFeedbackResultApiInterface
     */
    postAiFeedbackResultConfirm(aiFeedbackResultId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * AIフィードバックリマインドAPI
     * @summary AIフィードバックリマインドAPI
     * @param {number} aiFeedbackResultId AIフィードバックID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiFeedbackResultApiInterface
     */
    postAiFeedbackResultRemind(aiFeedbackResultId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for postAiFeedbackResultCancelReminder operation in AiFeedbackResultApi.
 * @export
 * @interface AiFeedbackResultApiPostAiFeedbackResultCancelReminderRequest
 */
export interface AiFeedbackResultApiPostAiFeedbackResultCancelReminderRequest {
    /**
     * AIフィードバックID
     * @type {number}
     * @memberof AiFeedbackResultApiPostAiFeedbackResultCancelReminder
     */
    readonly aiFeedbackResultId: number
}

/**
 * Request parameters for postAiFeedbackResultConfirm operation in AiFeedbackResultApi.
 * @export
 * @interface AiFeedbackResultApiPostAiFeedbackResultConfirmRequest
 */
export interface AiFeedbackResultApiPostAiFeedbackResultConfirmRequest {
    /**
     * AIフィードバックID
     * @type {number}
     * @memberof AiFeedbackResultApiPostAiFeedbackResultConfirm
     */
    readonly aiFeedbackResultId: number
}

/**
 * Request parameters for postAiFeedbackResultRemind operation in AiFeedbackResultApi.
 * @export
 * @interface AiFeedbackResultApiPostAiFeedbackResultRemindRequest
 */
export interface AiFeedbackResultApiPostAiFeedbackResultRemindRequest {
    /**
     * AIフィードバックID
     * @type {number}
     * @memberof AiFeedbackResultApiPostAiFeedbackResultRemind
     */
    readonly aiFeedbackResultId: number
}

/**
 * AiFeedbackResultApi - object-oriented interface
 * @export
 * @class AiFeedbackResultApi
 * @extends {BaseAPI}
 */
export class AiFeedbackResultApi extends BaseAPI implements AiFeedbackResultApiInterface {
    /**
     * AIフィードバックリマインドキャンセルAPI
     * @summary AIフィードバックリマインドキャンセルAPI
     * @param {AiFeedbackResultApiPostAiFeedbackResultCancelReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiFeedbackResultApi
     */
    public postAiFeedbackResultCancelReminder(requestParameters: AiFeedbackResultApiPostAiFeedbackResultCancelReminderRequest, options?: AxiosRequestConfig) {
        return AiFeedbackResultApiFp(this.configuration).postAiFeedbackResultCancelReminder(requestParameters.aiFeedbackResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * AIフィードバック確認API
     * @summary AIフィードバック確認API
     * @param {AiFeedbackResultApiPostAiFeedbackResultConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiFeedbackResultApi
     */
    public postAiFeedbackResultConfirm(requestParameters: AiFeedbackResultApiPostAiFeedbackResultConfirmRequest, options?: AxiosRequestConfig) {
        return AiFeedbackResultApiFp(this.configuration).postAiFeedbackResultConfirm(requestParameters.aiFeedbackResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * AIフィードバックリマインドAPI
     * @summary AIフィードバックリマインドAPI
     * @param {AiFeedbackResultApiPostAiFeedbackResultRemindRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiFeedbackResultApi
     */
    public postAiFeedbackResultRemind(requestParameters: AiFeedbackResultApiPostAiFeedbackResultRemindRequest, options?: AxiosRequestConfig) {
        return AiFeedbackResultApiFp(this.configuration).postAiFeedbackResultRemind(requestParameters.aiFeedbackResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
